import React, { useEffect, useRef } from 'react';
import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { arraysEqual } from '../helpers/objectDiff.js';
import RoomStatusProgress from './RoomStatusProgress.jsx';
import RoomStatusComplete from './RoomStatusComplete.jsx';
import { useRoom } from '../context/RoomContext.jsx';

const UserItem = ({ user, index, isFinalStep, isPodium, usersRef, questions, children, handleUserClick, className }) => {
	const { roomState, setRoomState } = useRoom();

	return (
		<>
			<div
				title={handleUserClick ? `Vai al dettaglio di ${user.nickName || user.displayName}` : ""}
				onClick={(ev) => handleUserClick?.(ev, user.sessionId)}	
				className={`user-item ${className ? className : "animate__animated animate__" + (isFinalStep ? 'fadeInLeft' : 'flipInX') }`}
				key={index}
				ref={(elRef) => {
					if (usersRef?.current) {
						usersRef.current[index] = elRef
					}
				}}
				style={{ animationDelay: isFinalStep ? (className ? `${200 * index}ms` : `${30 * index}ms` ) : '0ms' }}
			>
				<div className={`d-flex w-100 ${isPodium ? "podium-bar" : "align-items-center" }`}>
					{isFinalStep ? (
						user.isCompleted || isPodium
							? <RoomStatusComplete index={index} isFinalStep={isFinalStep} isPodium={isPodium} item={user} />
							: <RoomStatusProgress
								isFinalStep={isFinalStep}
								status={roomState.isPanelOpen}
								item={user}
								index={index}
								total={questions?.length} />
					) : (
							<RoomStatusProgress isFinalStep={isFinalStep} status={roomState.isPanelOpen} item={user} index={index} total={questions.length} />
					)}
				</div>

				{children}
			</div>

		</>
	);
};

export default UserItem;
